/* eslint-disable */
import { UOM } from "./uom";

export class QuantityView {

    quantity: number | undefined;
    uom: UOM | undefined;

}